export const CreateKeyedStorage = (prefix: string = "default") => {
	return {
		prefix: prefix,
		setItem: (k: string, v: string) => localStorage.setItem(prefix + "_" + k, v),
		getItem: (k: string) => localStorage.getItem(prefix + "_" + k),
		removeItem: (k: string) => localStorage.removeItem(prefix + "_" + k),
	};
};
